import type { ReactNode } from 'react';
import { styled } from 'styled-components';

export const StyledMenuItemLabel = styled.span`
  /* avoid no-empty-source rule */
`;

export type MenuItemLabelProps = {
  /**
   * The content of the label
   */
  children: ReactNode;
};

export const MenuItemLabel = ({ children }: MenuItemLabelProps) => {
  return <StyledMenuItemLabel>{children}</StyledMenuItemLabel>;
};
